import React from 'react'

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
// import { Component } from '@wordpress/element';

/**
 * Internal dependencies
 */
// import Button from '../button';
// import Dashicon from '../dashicon';

class PanelBody extends React.Component {
	constructor( props ) {
		super( ...arguments );
		this.state = {
			opened: props.initialOpen === undefined ? true : props.initialOpen,
		};
		this.toggle = this.toggle.bind( this );
	}
	// togglePanel
	toggle( event ) {
		event.preventDefault();
		if ( this.props.opened === undefined ) {
			this.setState( ( state ) => ( {
				opened: ! state.opened,
			} ) );
		}

		if ( this.props.onToggle ) {
			this.props.onToggle();
		}
	}

	// componentDidMount() {
	componentDidUpdate(prevProps, prevState) {
	// componentWillUpdate(nextProps, nextState) {
		 
		 
		 

		if ( this.state.opened &&
			 undefined !== this.props.currentPanel &&
			 this.props.currentPanel !== this.props.panelId  ) {

			 

			this.setState( ( state ) => ( {
				opened: false,
			} ) );

		} else {
			 
		}

		// if ( nextProps.currentPanel !== nextProps.panelId  ) {
		// 	this.setState( ( state ) => ( {
		// 		opened: false,
		// 	} ) );
		// }
	}

	render() {
		const { title, children, opened, className } = this.props;
		const isOpened = opened === undefined ? this.state.opened : opened;
		const icon = "dashicon arrow-${ isOpened ? 'down' : 'right' }";
		const classes = classnames( 'stlst-components-panel__body', className, { 'is-opened': isOpened } );

		let iconTriangleSVG = 'M8 6l6 4.03L8 14V6z'

		if ( isOpened ) {
			iconTriangleSVG = 'M15 8l-4.03 6L7 8h8z'
		}

		return (
			<div className={ classes }>
				{ !! title && (
					<h3 className="stlst-components-panel__body-title">
						<button
							className="stlst-components-button stlst-components-panel__body-toggle"
							onClick={ this.toggle }
							aria-expanded={ isOpened }
						>
							<svg aria-hidden="true" role="img" focusable="false" className={icon} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d={iconTriangleSVG}></path></svg>

							{ title }
						</button>
					</h3>
				) }

				{ isOpened && children && (<div className="stlst-components-panel__body-content">
					{ isOpened && children }
					{/* {children} // We need rendered content to stay always on the page. */}
				</div> ) }
			</div>
		);
	}
}

export default PanelBody;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/panel/body.js